import styled from "styled-components";

const AlternateMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default AlternateMain;
